<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div class="max-w-2xl mx-auto">
            <Card>
                <template #content>
                    <div class="paddle-checkout-container"></div>
                </template>
            </Card>
        </div>
        <div class="mb-20"></div>
    </AppLayout>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue'
    import Plan from '@/App/Plan/Entity/Plan'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import { initializePaddle, type Paddle } from '@paddle/paddle-js'
    import Card from '@/Shared/Component/Card.vue'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'

    interface CreateSubscriptionProps {
        pageMeta: PageMeta
        appSharedDataData: any
        planData: any
        paddleCustomerId: string
        paddleClientToken: string
        paddleEnvironment: 'sandbox' | 'production'
    }

    const props = defineProps<CreateSubscriptionProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const plan = ref<Plan>(Plan.hydrateSingle(props.planData))

    onMounted(() => {
        initializePaddle({
            environment: props.paddleEnvironment,
            token: props.paddleClientToken,
            pwCustomer: {
                id: props.paddleCustomerId ?? undefined,
            },
            checkout: {
                settings: {
                    displayMode: 'inline',
                    variant: 'one-page',
                    frameTarget: 'paddle-checkout-container',
                    frameStyle:
                        'width: 100%; min-width: 312px; background-color: transparent; border: none;',
                    frameInitialHeight: 450,
                    allowLogout: true,
                    showAddDiscounts: true,
                    allowDiscountRemoval: true,
                    showAddTaxId: true,
                },
            },
            eventCallback(event) {
                // TODO: Do something with this events
            },
        }).then((instance: Paddle | undefined) => {
            instance?.Checkout.open({
                customer: {
                    id: props.paddleCustomerId,
                },
                items: [
                    {
                        priceId: plan.value.paddlePriceId ?? '',
                        quantity: 1,
                    },
                ],
            })
        })
    })
</script>
